export default __webpack_public_path__ + "static/media/team99.144bc0f3.JPG";